import React, { useState } from 'react'
import { l } from '@manychat/manyui'

import { NODE_OPEN_FLOW_BUTTON_ID } from 'common/builder/components/chart/FlowChart/constants/index'

import { ButtonCaption, ButtonHover, Button } from './OpenFlowButton.styles'

interface OpenFlowButtonProps {
  onClick: () => void
}

export const OpenFlowButton = React.memo(({ onClick }: OpenFlowButtonProps) => {
  const [isHover, setHover] = useState(false)
  const style = isHover ? ButtonHover : Button

  return (
    <view
      style={style}
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      cursor={'pointer'}
      name={NODE_OPEN_FLOW_BUTTON_ID}
    >
      <richtext style={ButtonCaption} text={l.translate('Open Automation')} />
    </view>
  )
})
